// Modified from github.com/shd101wyy/mume

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewHeadingIDGenerator = this.HyperMD.PreviewHeadingIDGenerator || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uslug = void 0;
    function uslug(str, separater) {
        if (separater === void 0) { separater = "-"; }
        return str.replace(/[\.\s!@#$%^&*()\-=_+~`[\]{}\\<>?\/\|（）【】:：，。]+/g, separater);
    }
    exports.uslug = uslug;
    var HeadingIdGenerator = /** @class */ (function () {
        function HeadingIdGenerator() {
            this.table = {};
        }
        HeadingIdGenerator.prototype.generateId = function (heading) {
            heading = heading.trim();
            heading = heading.replace(/。/g, ""); // sanitize
            var slug = uslug(heading);
            if (this.table[slug] >= 0) {
                this.table[slug] = this.table[slug] + 1;
                slug += "-" + this.table[slug];
            }
            else {
                this.table[slug] = 0;
            }
            return slug;
        };
        return HeadingIdGenerator;
    }());
    exports.default = HeadingIdGenerator;
});
